module.exports = "  <details id=\"details\" ng-open=\"open\" *ngFor=\"let categ of dataService.AllCategories\">\n    <summary><span></span> {{categ.name}}</summary>\n    <ul>\n      <li *ngFor=\"let entry of categ.entries\"><a href=\"view#\" (click)=\"dataService.setEntry(entry)\">{{entry.description}}</a></li>\n    </ul>\n  </details>"


//////////////////
// WEBPACK FOOTER
// ./src/app/template/password-viewer/categories/categories.component.html
// module id = ./src/app/template/password-viewer/categories/categories.component.html
// module chunks = main